import type { HttpClient } from "../http";
import type { CreateSettlementRunRequest, SettlementRunDTO } from "../types";

export function settlementsResource(http: HttpClient) {
  return {
    list: () => http.get<SettlementRunDTO[]>("/settlements"),
    get: (id: number) => http.get<SettlementRunDTO>(`/settlements/${id}`),
    create: (body: CreateSettlementRunRequest) =>
      http.post<SettlementRunDTO>("/settlements", body),
    finalize: (id: number) => http.post<SettlementRunDTO>(`/settlements/${id}/finalize`),
  };
}
